import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-return-key",
  "use": "icon-return-key-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol viewBox=\"0 0 16 12\" id=\"icon-return-key\"><path d=\"M15 8.24H3.529l2.13 1.937a1.07 1.07 0 01.094 1.468.973.973 0 01-1.412.098l-4-3.64a1.068 1.068 0 010-1.566l4-3.64a.973.973 0 011.412.098 1.07 1.07 0 01-.094 1.468l-1.947 1.77H14v-5.23C14 .449 14.448 0 15 0s1 .449 1 1.003v6.233c0 .554-.448 1.003-1 1.003z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol